
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M37.333 19.556h-7.937L22.098 6.782a1.112 1.112 0 00-.965-.56h-4.55a1.11 1.11 0 00-1.067 1.416l3.405 11.918h-7.143l-3-4c-.21-.28-.54-.445-.89-.445H5.113a1.11 1.11 0 00-1.078 1.38L6.222 24l-2.188 7.508a1.11 1.11 0 001.078 1.38h2.777c.35 0 .679-.164.889-.444l3-4h7.143l-3.405 11.917c-.203.71.33 1.417 1.068 1.417h4.549c.398 0 .766-.214.964-.56l7.3-12.774h7.936C39.788 28.444 44 26.454 44 24c0-2.455-4.212-4.444-6.667-4.444z","fill":"#535353"}})])
          )
        }
      }
    